import ApiService from '@/services/core/api.service'

const DashboardService = {
  async get (query = '') {
    return ApiService.get(`financial-operation-manager/dashboard?${query}`)
  }
}

export default DashboardService
